import { render, staticRenderFns } from "./dataQuery.vue?vue&type=template&id=e74f1c14&scoped=true"
import script from "./dataQuery.vue?vue&type=script&lang=js"
export * from "./dataQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74f1c14",
  null
  
)

export default component.exports